import styled from 'styled-components';
export const SeparatorWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  margin: -5px 0;

  @media screen and (max-width: 470px) {
    margin: 0;
  }
`;
export const SeparatorText = styled.span `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #8f8f8f;
  white-space: nowrap;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 0px;
    height: 1px;
    background-color: #8f8f8f;
    border-radius: 1px;
    margin: 0 12px;
  }

  &::before {
    margin-left: 0;
  }
  &::after {
    margin-right: 0;
  }
`;
